import React from 'react';
import {
  FaRegFolderOpen,
  FaRegFileCode,
  FaRegCheckSquare,
  FaRegStickyNote,
  FaCubes,
} from 'react-icons/fa';
import { TREE_ITEM_TYPES } from './AppEnums';

export const TREE_ICONS = {
  [TREE_ITEM_TYPES.FOLDER]: <FaRegFolderOpen style={{ fontSize: "24px", color: "#276EF1" }} />,
  [TREE_ITEM_TYPES.OBJECT]: <FaCubes style={{ fontSize: "24px", color: "#276EF1" }} />,
  [TREE_ITEM_TYPES.FILE]: <FaRegFileCode style={{ fontSize: "24px", color: "#276EF1" }} />,
  [TREE_ITEM_TYPES.GROUP]: <FaRegStickyNote style={{ fontSize: "24px", color: "#276EF1" }} />,
  [TREE_ITEM_TYPES.NUMERIC]: <FaRegCheckSquare style={{ fontSize: "24px" }} />,
  [TREE_ITEM_TYPES.MULTIOPTION]: <FaRegCheckSquare style={{ fontSize: "24px" }} />,
  [TREE_ITEM_TYPES.TEXT]: <FaRegCheckSquare style={{ fontSize: "24px" }} />,
};